import { graphql } from "gatsby"
import React from "react"
import Layout from "../components/layout"
import repertoire from "../../locales/repertoire.json"
import { Fragment } from "react"
import { useTranslation } from "gatsby-plugin-react-i18next"
import Seo from "../components/seo"

const RepertoirePage = () => {
  const { t } = useTranslation()

  const accordeonOpen = id => {
    const element = document.getElementById(id)
    element.classList.contains("open")
      ? element.classList.remove("open")
      : document
          .querySelectorAll(".repertoire")
          .forEach(el =>
            el.id === id
              ? document.getElementById(id).classList.add("open")
              : el.classList.remove("open")
          )
  }

  return (
    <Layout page="repertoire">
      <Seo title="Repertoire" />
      <div className="page_container">
        <div className="repertoire-container">
          {repertoire.map(({ country, styles }) => (
            <div id={country} key={country} className="repertoire">
              <button
                className="repertoire__title"
                onClick={() => accordeonOpen(country)}
              >
                <h3>{t(country)}</h3>
              </button>
              <div className="repertoire__accordeon">
                {styles.map(({ type, composers }) => (
                  <div key={type}>
                    <h4>{t(type)}</h4>
                    <ul>
                      {composers.map(({ name, pieces }) => (
                        <Fragment key={name}>
                          <li>{name}</li>
                          <ul className="pieces">
                            {pieces.map((piece, i) => (
                              <li key={i}>{t(piece)}</li>
                            ))}
                          </ul>
                        </Fragment>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default RepertoirePage

export const query = graphql`
  query($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
